import React, { useEffect, useState } from "react";
import "./Styles/flash.css";
import rectangle from "../Images/Icones/Rectangle.svg";
import Carousel from "better-react-carousel";
import FlashSVG from "../Images/vente_flash.svg";
import moment from "moment";
import FlashCard from "./FlashCard";
export const Flash = ({ products,endAt }) => {
  const [remainingTime, setRemainingTime] = useState(
    moment.duration(endAt.diff(moment()))
  );

  useEffect(() => {
    const intervalId = setInterval(() => {
      setRemainingTime(moment.duration(endAt.diff(moment())));
    }, 1000);
    return () => clearInterval(intervalId);
  }, [endAt]);

  const days = remainingTime.days().toString().padStart(2, "0");
  const hours = remainingTime.hours().toString().padStart(2, "0");
  const minutes = remainingTime.minutes().toString().padStart(2, "0");
  const seconds = remainingTime.seconds().toString().padStart(2, "0");

  return (
    <div style={{background: "white", width: "90%", margin: "25px auto", borderRadius: "25px", overflow: "hidden"}}>
      <header className='flexcenter' style={{marginBottom:"10px"}}>
        <div className='flexcenter bot-headers'>
          <div className='flexcenter leftheaders'>
            <img src={rectangle} alt='rectangle' />
            <span>Vente Flash</span>
            <img style={{ width: "50px" }} src={FlashSVG} alt='flash' />
          </div>
          <div className='flexcenter right-side'>
            <div className='flash-time'>
              <span className='day-span'>{days}</span>
              <span className='hour-span'>{hours}</span>
              <span className='minute-span'>{minutes}</span>
              <span className='second-span'>{seconds}</span>
            </div>
          </div>
        </div>
      </header>
      <div className='flash-carousel vente-flash'>
        <Carousel cols={5} rows={1} gap={15} loop={true} autoplay={3000}>
          {products.map((x, index) => {
            return (
              <Carousel.Item key={"flashProducts" + index}>
                <FlashCard product={x.product} />
              </Carousel.Item>
            );
          })}
        </Carousel>
      </div>
    </div>
  );
};
